import React from 'react';
import PropTypes from 'prop-types';

/**
 * Componente para mostrar el resumen de subtotal, IVA y total en el carrito de productos
 */
const ResumenOrden = ({ totales }) => {
    return (
        <>
            <tr className="border-bottom">
                <th className="ps-0">Subtotal</th>
                <th className="pe-0 text-end">${totales.dSubtotal.toFixed(2)}</th>
            </tr>
            <tr>
                <th className="ps-0 pb-0">I.V.A. (Para el Gobierno de M&eacute;xico)</th>
                <th className="pe-0 text-end pb-0">${totales.dIVA.toFixed(2)}</th>
            </tr>
        </>
    );
};

ResumenOrden.propTypes = {
    totales: PropTypes.shape({
        dSubtotal: PropTypes.number.isRequired,
        dIVA: PropTypes.number.isRequired
    }).isRequired
};

export default ResumenOrden;
